<template>
  <div class="echart09">
    <div ref="echart09" style="width:100%; height:200px;"></div>
  </div>
</template>

<script>
export default {
  mounted() {
    let chart09 = this.$echarts.init(this.$refs.echart09)
    var data ={
      xData:["01", "02", "03", "04", "05", "06", "07"],
      yData1:["20", "18", "28", "9", "16", "20", "30"],
      yData2:["32", "38", "20", "18", "28", "9", "16"],
      yName1:"巡更总数",
      yName2:"异常数",
      // yLabel:"单位:mg/L"
      yLabel:""
    }
    let option = {
      backgroundColor:'',
      legend:{
        show:true,
        top:'6%',
        right:'5%',
        itemWidth:25,
        itemHeight:14,
        textStyle:{
          color:'#fff',
          fontSize:14,
          padding:[0,8,0,8]
        },
        data:[data.yName1,data.yName2]
      },
      tooltip:{
        trigger:'axis',
        axisPointer:{
          type:'shadow',
          label:{
            show:true,
            fontSize:14,
            borderColor:'#fff',
            shadowOffsetY:0,
          }
        }
      },
      grid:{
        left:'3%',
        right:'4%',
        top:'20%',
        bottom:'20%',
        containLabel:true
      },
      xAxis:[{
        type:'category',
        data:data.xData,
        axisTick:{
          show:false,
        },
        axisLabel:{
          textStyle:{
            color:"#FFFFFF",
            fontSize:14,
            fontWeight:400
          },
        },
        axisLine:{
          show:true,
          lineStyle:{
            color:"rgba(12,116,123,0.5)",
          },
        },
      }],
      yAxis:[{
        type:'value',
        min:0,
        max:50,
        name:data.yLabel,
        nameTextStyle:{
          color:"#FFFFFF",
        },
        boundaryGap:false,
        axisTick:{
          show:false,
        },
        axisLabel:{
          textStyle:{
            color:"#FFFFFF",
            fontSize:14,
            fontWeight:400
          },
        },
        splitLine:{
          show:false,
          lineStyle:{
            color:"rgba(12,116,123,0.5)",
          },
        },
        axisLine:{
          show:false,
          lineStyle:{
            color:"rgba(12,116,123,0.5)",
          },
        },
      }],
      series:[{
        name:data.yName1,
        type:'bar',
        data:data.yData1,
        barWidth:15,
        itemStyle:{
          color:'#0fe2d9'
          // color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
          //   {
          //     offset: 0,
          //     color: "#09CDFF",
          //   },
          //   {
          //     offset: 1,
          //     color: "#a90000",
          //   },
          // ]),
        }
      },
      {
        name:data.yName2,
        type:'bar',
        data:data.yData2,
        barWidth:15,
        barGap:"0",
        // barCategoryGap:"30%",
        itemStyle:{
          color:'#f49434'
          // normal:{
          //   color:this.$echarts.graphic.LinearGradient(0,1,0,0,[
          //     {
          //       offset:0,
          //       color:'#1d3262',
          //     },
          //     {
          //       offset:1,
          //       color:'#f49434',
          //     },
          //   ]),
          // }
        }
      },
      ],
    }
    chart09.setOption(option, true)
  }
}
</script>

<style>
.echart09 {
  font-size: 10px;
  font-weight: 700;
  width: 100%;
}
</style>
